import { canAccessInsightsResponseSchema } from './canAccessInsights.schema';

export type CanAccessInsightsResponse = {
  canAccessInsights: boolean;
};

export const canAccessInsights = () => {
  return {
    endpoint: `/internal/metabase/can_access_insights`,
    method: 'GET',
    responseSchema: canAccessInsightsResponseSchema,
  } as const;
};
